import {createApp} from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import {createPinia} from "pinia"
import {useAuthStore} from './stores/auth.store'
import 'primeicons/primeicons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Ripple from 'primevue/ripple'
import {createI18n} from 'vue-i18n'
import fr from './locales/fr.json'
import Tooltip from 'primevue/tooltip'
import primeVueFr from 'primelocale/fr.json'

startApp()

export const i18n = createI18n({
    locale: 'fr',
    fallbackLocale: 'fr',
    messages: {fr},
    warnHtmlInMessage: "off"
})

async function startApp(): Promise<void> {
    const app = createApp(App)
    app.use(PrimeVue, {
        theme: {
            preset: Aura,
            options: {
                darkModeSelector: '.theme-dark',
            }
        },
        locale: primeVueFr.fr
    })
    app.use(createPinia())

    try {
        const authStore = useAuthStore();
        await authStore.checkCredentials();
    } catch {
        // catch error to start app on success or failure
    }
    app.use(router)
    app.use(ToastService)
    app.use(ConfirmationService)
    app.directive('ripple', Ripple);
    app.directive('tooltip', Tooltip);
    app.use(i18n)

    app.mount('#app')
}
